module.exports = __webpack_public_path__ + "img/9.0902336e.svg";